import { VueNodeViewRenderer, UneditableNodeView } from "@wagich/bluc-backendapp";
import { Node } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        contactForm: {
            insertContactForm: () => ReturnType,
        }
    }
}

const TagName = "contact-form";

export const ContactForm = Node.create({
    name: "contactForm",
    atom: true,
    group: "block",
    draggable: true,
    defaultOptions: {
        text: "Kontaktformular"
	},
    addNodeView() {
        return VueNodeViewRenderer(UneditableNodeView);
    },
    addCommands() {
        return {
            insertContactForm: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            }
        }
    },
    parseHTML() {
        return [{ tag: TagName }]
    },
    renderHTML({ HTMLAttributes }) {
        return [TagName, HTMLAttributes];
    }
});
